import { render, staticRenderFns } from "./GenericForm.vue?vue&type=template&id=94e1e0f4"
import script from "./GenericForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports